import { SearchModel } from "./search";
import { backboneModelProperties } from "./../../decorators/backbone-properties";
import {prop} from "../../decorators/property";

@backboneModelProperties({
    relations: [{
        type: Backbone.Many,
        key: "SubFacets",
        relatedModel: FacetModel
    }]
})
export class FacetModel extends Backbone.AssociatedModel {

    @prop() public Count: number;
    @prop() public Enabled: boolean;
    @prop() public Ticked: boolean;
    @prop() public PartiallyTicked: boolean;
    @prop() public Label: string;
    @prop() public Name: string;
    @prop() public SubFacets: Backbone.Collection<FacetModel>;
    @prop() public HasSubFacets: boolean;
    public searchModel: SearchModel;

    constructor(options?: any) {
        super(options);

        this.Label = this.toTitleCase(this.Label);
    }

    public toTitleCase(orig: string): string { // added check for >2 length to prevent EU getting decapitalised. Might not be perfect in every single case but will suffice for all our current facets.
        if (!orig) {
            return orig;
        }
        return orig.replace(/\w\S*/g, (txt) => txt.length > 2 ? txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase() : txt);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/models/facet.ts